<template>
  <div class="cell small-12 medium-10">
    <div class="grid-x">
      <div v-for="index in 2" :key="index" class="cell small-8 medium-6 margin-right-xxs margin-top-xs">
        <Skeleton height="40px" />
      </div>
    </div>
    <div class="grid-x grid-padding-y">
      <div v-for="index in 2" :key="index" class="cell">
        <Skeleton height="150px" />
      </div>
    </div>
    <div class="grid-x grid-padding-y">
      <div class="cell medium-6">
        <Skeleton height="180px" />
      </div>
      <div class="cell medium-6">
        <Skeleton height="180px" />
      </div>
      <div class="cell medium-6">
        <Skeleton height="180px" />
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton.vue';
</script>
